import script from "./ClubRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubRoute.vue?vue&type=script&setup=true&lang=js"

import "./ClubRoute.vue?vue&type=style&index=0&id=49abfb41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49abfb41"]])

export default __exports__